import angular from 'angular'

import ggsAttr from '../ggs-attr'
import ggsTimeago from '../ggs-timeago'
import ggsFastSwitch from '../ggs-fast-switch'
import ggsBackgroundImage from '../ggs-background-image'

export default angular
  .module('ggs.user', [
    ggsAttr,
    ggsTimeago,
    ggsFastSwitch,
    ggsBackgroundImage
  ])
  .name
